import { Button } from '@/components/ui/button'
import type { ViewDef } from '../query/types'

/**
 * "Weergave gewijzigd" (design §5.4): the filters, columns or sort differ from the view. A saved
 * view the user may edit can be overwritten; any view can be saved as a new one; "Herstellen" goes
 * back to the view. The search term does not count.
 */
export function ViewChangedBar({
  view,
  busy,
  onSave,
  onSaveAsNew,
  onReset,
}: {
  view: ViewDef
  busy: boolean
  onSave: () => void
  onSaveAsNew: () => void
  onReset: () => void
}) {
  return (
    <div role="status" className="flex flex-wrap items-center gap-2 rounded-lg border border-dashed border-border bg-muted px-3 py-2 text-sm">
      <span className="font-medium">Weergave gewijzigd</span>
      {!view.system && view.can_edit ? (
        <Button type="button" variant="outline" size="sm" disabled={busy} onClick={onSave}>
          Opslaan
        </Button>
      ) : null}
      <Button type="button" variant="outline" size="sm" disabled={busy} onClick={onSaveAsNew}>
        Opslaan als nieuwe weergave
      </Button>
      <Button type="button" variant="ghost" size="sm" disabled={busy} onClick={onReset}>
        Herstellen
      </Button>
    </div>
  )
}
